var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"a"},[(_vm.targetText)?_c('vue-qrcode',{attrs:{"value":_vm.targetText,"options":_vm.option,"tag":"img"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }